// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCNAZ_LdHvSfSYbL7PS6qnNcG-tjCQygBc",
  authDomain: "my-blog-fa9f6.firebaseapp.com",
  projectId: "my-blog-fa9f6",
  storageBucket: "my-blog-fa9f6.appspot.com",
  messagingSenderId: "397489127234",
  appId: "1:397489127234:web:3cc8bfd1f3dc7c7e7992db"
};

// Initialize Firebase
initializeApp(firebaseConfig);
export const db = getFirestore();